<template>
  <div class="home">
      <FloatingBtn />
    
    <iframe :src="iframe" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" allowtransparency="true"
      frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen seamless="seamless"
      mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen width="100%" height="100%"></iframe>
  </div>
</template>

<script>
  // @ is an alias to /src
    import FloatingBtn from './../components/FloatingBtn.vue'

  export default {
    name: 'Home',
    components: {
        FloatingBtn
    },
    data() {
      return {
        iframe: this.$store.state.gameLink,
        menu: false
      }
    },
    methods: {
      openMenu() {
        this.menu = !this.menu
      }
    }
  }
</script>
<style lang="less" scoped>
  iframe {
    width: 100vw;
    height: 100vh;
    border: none;
  }
  @media (orientation: portrait) {
        iframe{
            width: 100vh;
            height: 100vw;
        }
    }
  #nav {
    background-color: rgba(12, 37, 82, 0.85);
    border: 1px solid #d5b35f;
    position: absolute;
    border-top: none;
    top: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    height: 35px;
    line-height: 35px;
    width: 40%;
    z-index: 1;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
    -ms-transform: skewX(20deg);
    /* IE 9 */
    -webkit-transform: skewX(20deg);
    /* Safari */
    transform: skewX(20deg);

    ul {
      display: inline-block;

      li {
        list-style-type: none;
        float: left;
        -ms-transform: skewX(-20deg);
        /* IE 9 */
        -webkit-transform: skewX(-20deg);
        /* Safari */
        transform: skewX(-20deg);

        a {
          text-decoration: none;
          padding: 10px;
          color: #d5b35f;
        }
      }
    }
  }

  #float-menu {
    background-color: rgba(255, 255, 255, .1);
    backdrop-filter: blur(1px);
    width: 75px;
    height: 75px;
    border-radius: 100%;
    display: inline-block;
    position: fixed;
    bottom: 20px;
    left: 20px;

    &.open {

      transition: width 1s;
      width: 300px;
      height: 300px;
      left: -92px;
      bottom: -92px;
    }

    .inner {
      background-color: rgba(255, 255, 255, .15);
      backdrop-filter: blur(5px);
      width: 50px;
      height: 50px;
      border-radius: 100px;
      display: inline-block;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      top: 50%;
      transform: translateY(-50%);

      img {
        width: 30px;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .items {
      position: relative;

      ul {
        li {
          position: absolute;
          display: inline-block;
          list-style-type: none;

          img {
            width: 30px;
          }

          &:first-child {
            right: 140px;
            top: 20px;
          }

          &:nth-child(2) {
            right: 70px;
            top: 40px;
          }

          &:nth-child(3) {
            right: 30px;
            top: 100px;
          }

          &:nth-child(4) {
            right: 40px;
            top: 170px;
          }
        }
      }
    }
  }


  
</style>
